"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("tlSelectConfigRegistry", function () {
  var registry = {};
  return {
    registerConfig: function registerConfig(configName, config) {
      registry[configName] = config;
    },
    getConfig: function getConfig(configName) {
      return registry[configName];
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/selectbox/tlSelectConfigRegistry.js
// module id = 2998
// module chunks = 13